import {useEffect, useMemo} from 'react';
import {createSelector} from '@reduxjs/toolkit';
import {useAppDispatch, useAppSelector} from '../../../hooks/redux';
import {calendarAPI} from '../../../services/CalendarServices';

export const useCalendarHolidays = (years: number[], enabled: boolean) => {
    const dispatch = useAppDispatch();
    const yearKey = enabled ? years.filter(year => year >= 1900 && year <= 2100).join(',') : '';
    const requestedYears = useMemo(() => yearKey ? yearKey.split(',').map(Number) : [], [yearKey]);
    useEffect(() => {
        const requests = requestedYears.map(year => dispatch(calendarAPI.endpoints.getCalendarHolidays.initiate(year)));
        return () => requests.forEach(request => request.unsubscribe());
    }, [dispatch, requestedYears]);
    const selectHolidays = useMemo(() => createSelector(
        requestedYears.map(year => calendarAPI.endpoints.getCalendarHolidays.select(year)),
        (...results) => new Map(results.flatMap(result => (result.data ?? []).map(holiday => [holiday.date, holiday] as const))),
    ), [requestedYears]);
    return useAppSelector(selectHolidays);
};
